"use client";

import { Modal, ModalContent, ModalHeader, ModalBody } from "@nextui-org/react";
import CreatePost from "@/components/CreatePost";
import { BasicUserType } from "@/types/user";

interface CreatePostModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  user: BasicUserType | null;
  onPost: Function;
}

export const CreatePostModal = ({
  open,
  onOpenChange,
  user,
  onPost
}: CreatePostModalProps) => {
  return (
    <Modal
      isOpen={open}
      onOpenChange={onOpenChange}
      size="2xl"
      className="bg-secondary"
    >
      <ModalContent>
        <ModalHeader className="text-xl">Create a post</ModalHeader>
        <ModalBody className="pb-6">
          <CreatePost
            handlePost={onPost}
            user={user}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default CreatePostModal;